import angular from 'angular';

angular
  .module('envelope')

  .factory('FolderService', [
    '$resource',
    'API_CONFIG',
    function($resource, API_CONFIG) {
      var Folder = $resource(
        API_CONFIG.url + '/v1/folder/:folderId',
        { folderId: '@id' },
        {
          // Recherche suivant les critères
          searchByCriterias: {
            url: API_CONFIG.url + '/v1/folder/searchByCriterias',
            method: 'POST',
            isArray: true
          },
          // Recherche auditLog pour le folder
          getAuditLogByFolder: {
            folderId: '@id',
            url: API_CONFIG.url + '/v1/folder/:folderId/history',
            method: 'GET'
          },
          // rejoue la validation de signature
          retrySignatureValidation: {
            url: API_CONFIG.url + '/v1/folder/renew-validations',
            method: 'GET'
          }
        }
      );

      return Folder;
    }
  ]);
